import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMagicLink = function SvgMagicLink(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#6851FF",
        d: "M61 12.031A117.4 117.4 0 0 0 75 26.3a114.7 114.7 0 0 0-5.194 34.231c0 11.916 1.818 23.411 5.194 34.232a117.4 117.4 0 0 0-14 14.268 117.4 117.4 0 0 0-14-14.268 114.7 114.7 0 0 0 5.194-34.232A114.7 114.7 0 0 0 47 26.3 117.4 117.4 0 0 0 61 12.03M35.733 88.031A123.6 123.6 0 0 0 18 78.143a56.3 56.3 0 0 0 2.653-17.112c0-5.953-.928-11.698-2.653-17.111a123.6 123.6 0 0 0 17.733-9.889 112.7 112.7 0 0 1 3.267 27c0 9.293-1.13 18.332-3.267 27M82 61.031c0 9.293 1.13 18.332 3.267 27A123.6 123.6 0 0 1 103 78.143a56.2 56.2 0 0 1-2.653-17.112c0-5.953.928-11.698 2.653-17.111a123.6 123.6 0 0 1-17.733-9.889 112.7 112.7 0 0 0-3.267 27"
    })));
};

export { SvgMagicLink as ReactComponent };
//# sourceMappingURL=MagicLink.svg.es.js.map
